import { getAccessToken } from '../auth/tokenService';

const API_BASE = process.env.REACT_APP_EXAM_API_URL || `${process.env.REACT_APP_API_URL || '/api'}/exam`;
const WS_BASE = process.env.REACT_APP_EXAM_WS_URL || `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}`;

function getAuthHeaders() {
  const token = getAccessToken();
  const headers = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
}

export async function testLogin(candidateId, name, process = 'sales') {
  const response = await fetch(`${API_BASE}/test-login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ candidate_id: candidateId, name, process })
  });
  return response.json();
}

export async function getExamPortal() {
  const response = await fetch(`${API_BASE}/examportal`, {
    credentials: 'include',
    headers: getAuthHeaders()
  });
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }
  return response.json();
}

export async function startSession(sessionId) {
  const response = await fetch(`${API_BASE}/examportal/session/${sessionId}/start`, {
    method: 'POST',
    credentials: 'include',
    headers: getAuthHeaders()
  });
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }
  return response.json();
}

export async function getEvaluation() {
  const response = await fetch(`${API_BASE}/examportal/evaluation`, {
    credentials: 'include',
    headers: getAuthHeaders()
  });
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }
  return response.json();
}

export function getWebSocketUrl(sessionId) {
  const token = getToken();
  const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const base = `${wsProtocol}//${window.location.host}`;
  const wsPath = process.env.REACT_APP_EXAM_WS_URL
    ? `${process.env.REACT_APP_EXAM_WS_URL}/ws/session/${sessionId}`
    : `${base}${API_BASE}/ws/session/${sessionId}`;
  if (token) {
    return `${wsPath}?token=${token}`;
  }
  return wsPath;
}

export function getToken() {
  // Try sessionStorage first (Cognito login), then cookie (test-login)
  const stored = getAccessToken();
  if (stored) return stored;
  const match = document.cookie.match(/session_token=([^;]+)/);
  return match ? match[1] : null;
}
